import styles from "./PopUpSpacer.module.css"

function PopUpSpacer({className}) {
    return (
        <div className={[styles.spacer, className].filter(e => !!e).join(' ')}>

        </div>
    )
}

export default PopUpSpacer;